import { useMemo, type MutableRefObject } from 'react';

import { Canvas } from '../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../core/components/canvas/CanvasContext.js';
import { CanvasShape } from '../../core/components/canvas/types/canvas-shape.js';
import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { DisplayConfigContext } from '../contexts/DisplayConfigContext.js';
import { BarChartDisplay } from '../displays/BarChartDisplay.js';
import { useHighlightedDimensionState } from '../hooks/store/selectors.js';
import { useCategoricalBarChartScales } from '../hooks/useCategoricalBarChartScales.js';

export const CategoricalCanvasLayout = () => {
  const { width, height } = useGridPlotSize();
  const { categoryScale, dimensionScale, valueScale } =
    useCategoricalBarChartScales();
  const highlightedDimension = useHighlightedDimensionState();

  const displayConfigContext = useMemo(
    () => ({
      highlightedDimension,
      categoryScale,
      dimensionScale,
      valueScale,
    }),
    [highlightedDimension, categoryScale, dimensionScale, valueScale],
  );

  return (
    <div className={plotLayout}>
      <CanvasContext.Provider
        value={{
          shapeRefs: new Map<string, MutableRefObject<CanvasShape>>(),
        }}
      >
        <Canvas width={width} height={height}>
          <DisplayConfigContext.Provider value={displayConfigContext}>
            <BarChartDisplay />
          </DisplayConfigContext.Provider>
        </Canvas>
      </CanvasContext.Provider>
    </div>
  );
};

CategoricalCanvasLayout['displayName'] = 'CategoricalCanvasLayout';
